import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useMenu } from '../../hooks/useMenu';
import BusinessTypeForm from '../../components/Forms/BusinessTypeForm';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import { HeadingSubtitle } from '../../components/Heading';
import themeColors from '../../assets/styles/themeColors';
import SaveAndCloseModal from '../../components/Modals/SaveAndCloseModal/SaveAndCloseModal';

const VerifyBusinessType = () => {
  const { t } = useTranslation();
  const { activeMenu, activeItem } = useMenu();
  const [eventType, setEventType] = useState('NoForm');
  const [saveAndCloseModalOpen, setSaveAndCloseModalOpen] = useState(false);

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
      setEventType={setEventType}
      eventType={eventType}
      setSaveAndCloseModalOpen={setSaveAndCloseModalOpen}
    >
      <HeadingSubtitle mb={32} color={themeColors.colorTextSecondary}>
        {t('verifyBusinessType.title')}
      </HeadingSubtitle>
      <BusinessTypeForm nextPath={activeItem?.nextPath} />
      {saveAndCloseModalOpen && (
        <SaveAndCloseModal
          isOpen={saveAndCloseModalOpen}
          onClose={() => setSaveAndCloseModalOpen(false)}
        />
      )}
    </OnBoardingContainer>
  );
};

export default VerifyBusinessType;
